<template>
  <b-row
    class="flex-nowrap mh-100 h-100 minimum-height"
    no-gutters
    @dragover="preventDrop"
    @dragenter="preventDrop"
  >
    <BuilderWizard />
    <SaveImageModal />
    <b-col
      v-if="appLoaded"
      style="min-width: 25rem; max-width: 25rem;"
      class="d-flex flex-column mh-100 orbviz-headers"
    >
      <BuilderNav class="px-3" />
      <simplebar class="d-flex mh-100 h-100 px-3 pb-3 minimum-height">
        <BuilderSidebar />
      </simplebar>
    </b-col>

    <b-col class="d-flex mh-100 w-100">
      <PublicView />
    </b-col>
  </b-row>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import PublicView from '@/views/PublicView.vue'
import BuilderNav from '@/components/builder/BuilderNav/BuilderNav.vue'
import BuilderWizard from '@/components/builder/BuilderWizard/BuilderWizard.vue'
import SaveImageModal from '@/components/builder/images/SaveImageModal.vue'
// @ts-ignore simplebar-vue import
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.css'
import BuilderSidebar from '@/views/BuilderSidebar.vue'

import { CLASS_TIPTAP_CONTAINER, ROUTE_READONLY_PRIMARY } from '@/constants'

const components = {
  BuilderNav,
  BuilderWizard,
  simplebar,
  SaveImageModal,
  PublicView,
  BuilderSidebar,
}

@Component({
  components,
  watch: {
    canBuild: {
      handler (canBuild: boolean) {
        // if the user does not have permission to build
        // then redirect them to the readOnly route
        if (!canBuild) {
          this.$router.push({
            name: ROUTE_READONLY_PRIMARY,
            params: this.$typedStore.currentRoute.params,
          })
        }
      },
      immediate: true,
    },
  },
})
export default class BuilderView extends Vue {
  get appLoaded () {
    return this.$typedStore.primary.app.appLoaded
  }

  get canBuild () {
    if (!this.appLoaded) {
      // if the app isn't loaded yet then we cannot correctly determine if the user
      // can build or not
      return true
    }

    return this.$typedStore.admin.userPermission.builder
  }

  beforeDestroy () {
    this.$typedStore.primary.entities.images.clearPreviews()
  }

  preventDrop (e: DragEvent) {
    e.preventDefault()
    if (e.dataTransfer) {
      if (e.target && this.parentIsTipTap(e.target as HTMLElement)) {
        e.dataTransfer.effectAllowed = 'copy'
        e.dataTransfer.dropEffect = 'copy'
      } else {
        e.dataTransfer.effectAllowed = 'none'
        e.dataTransfer.dropEffect = 'none'
      }
    }
  }

  parentIsTipTap (element: HTMLElement): Boolean {
    const className = 'ProseMirror'
    if (!element.parentNode || this.hasClass(element, CLASS_TIPTAP_CONTAINER)) {
      // Do not need to look further up the tree than the tiptap-container
      return false
    }
    if (this.hasClass(element, className)) {
      // Only want editable TipTap elements
      return element.contentEditable === 'true'
    }
    return this.parentIsTipTap(element.parentNode as HTMLElement)
  }

  hasClass (element: HTMLElement, className: string) {
    return element.classList && element.classList.contains(className)
  }
}

</script>
